import React from "react";

const CountDown = ({title, number}) => {
  return (
    <div>
      <h1>{(number < 10) ? '0' + number : number}</h1>
      <span>{title}</span>
    </div>
  )
}

export default CountDown